import { cn } from "@/lib/utils";

interface TableCardProps {
  children: React.ReactNode;
  className?: string;
}

export function TableCard({ children, className }: TableCardProps) {
  return (
    <div
      className={cn(
        "rounded-xl border border-black/5 bg-white shadow-sm overflow-hidden",
        className,
      )}
    >
      {children}
    </div>
  );
}
